import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ClientDocumentMainWrapper = styled.div`
  .header-doc {
    ${responsive.MOBILE`
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    `}
  }
`;
